import { BehaviorSubject } from 'rxjs'
import Category from '@/interfaces/category.interface'
export default new BehaviorSubject<Array<Category>>([])
const onLoadingCategories = new BehaviorSubject<boolean>(false)
export { onLoadingCategories }
